// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root___swFS","footer":"ModalFilter_footer__2CvhQ"};